import App from '../assets/app.svg'
import Biceps from '../assets/biceps.svg'
import ChestPress from '../assets/chestpress.svg'
import Frequency from '../assets/clock.svg'
import Crunch from '../assets/crunch.svg'
import Gym from '../assets/gym.svg'
import Latraise from '../assets/latraise.svg'
import LegCurl from '../assets/legcurl.svg'
import LegPress from '../assets/legpress.svg'
import Progression from '../assets/progression.svg'
import SeatedRow from '../assets/seatedrow.svg'
import Triceps from '../assets/triceps.svg'
import Volume from '../assets/volume.svg'
import { MagneticWeights } from '../components/affiliates/Lifting'
import { Footnote } from '../components/curriculum/Footnote'
import { Divider } from '../components/divider/Divider'
import { Explanation } from '../components/explanation/Explanation'
import { Image } from '../components/image/Image'
import { Layout } from '../components/Layout'

const Lifting = () => {
  return (
    <Layout>
      <div className={'w90 center module'}>
        <h1 className="huge mb10">Lifting</h1>
        <Explanation className="mb40" color="blue">
          <div>
            <strong>Why: </strong> Live longer and get stronger while sitting
            down. Zero skill required.
          </div>
        </Explanation>
        <div>
          <h2 className="tcenter mt25 mb0">Required</h2>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Machine chest press"
                src={ChestPress}
              />
              <div className="ml20">
                <div>
                  <strong>Chest press</strong>
                </div>
                <div>Chest, shoulders, arms</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=2y6ntGVg4dw">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Rowing machine"
                src={SeatedRow}
              />
              <div className="ml20">
                <div>
                  <strong>One-arm row</strong>
                </div>
                <div>Back, shoulders, arms</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=3EP5HpKtJG0">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Single leg press"
                src={LegPress}
              />
              <div className="ml20">
                <strong>Single leg press</strong>
                <div>Butt and legs</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=c37iiT2xRN0">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <h2 className="tcenter mt25 mb20">Optional</h2>
          <Explanation color="yellow" className="mb30">
            <div>
              <strong>Heads up: </strong> These exercises are optional.{' '}
              <strong>Seriously</strong>. Sure, they{`'`}ll deliver about 50%
              more muscle growth in your arms, shoulders, quadriceps, butt, and
              core. However, they{`'`}ll also <strong>double or triple</strong>{' '}
              the length of your workout. Hence, we only recommend them for the
              truly dedicated!
            </div>
          </Explanation>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Leg extension machine"
                src={LegCurl}
              />
              <div className="ml20">
                <div>
                  <strong>Leg extensions</strong>
                </div>
                <div>Legs (front)</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=YyvSfVjQeL0">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Lateral raise machine"
                src={Latraise}
              />
              <div className="ml20">
                <div>
                  <strong>Cable hip abduction</strong>
                </div>
                <div>Butt (side) </div>
                <div>
                  <a href="https://www.youtube.com/watch?app=desktop&v=1rbpTTzEnV4">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Crunch machine"
                src={Crunch}
              />
              <div className="ml20">
                <div>
                  <strong>Seated crunch</strong>
                </div>
                <div>Core (front)</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=_O1xunCfYEM">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Lateral raise machine"
                src={Latraise}
              />
              <div className="ml20">
                <div>
                  <strong>Lateral raises</strong>
                </div>
                <div>Shoulders</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=0FUpcwj_1z4">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Triceps extension machine"
                src={Triceps}
              />
              <div className="ml20">
                <div>
                  <strong>Tricep extensions</strong>
                </div>
                <div>Arms (back)</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=cBt1X8fwKKc">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="fr">
              <Image
                width={120}
                height={120}
                alt="Bicep curl machine"
                src={Biceps}
              />
              <div className="ml20">
                <div>
                  <strong>Bicep curls</strong>
                </div>
                <div>Arms (back)</div>
                <div>
                  <a href="https://www.youtube.com/watch?v=M_uPvGrMx_o">
                    Instructions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Divider className="mb20 mt20" height={4} />
        <div>
          <h2 className="mb0">Routine</h2>
          <div>
            <div className="fr mt40 mb40">
              <Image width={60} height={60} alt="Phone" src={App} />
              <div className="ml20">
                Download the free{' '}
                <a href="https://www.strong.app">Strong app</a> to track your
                workout.
              </div>
            </div>
          </div>
          <div>
            <div className="fr mt40 mb40">
              <Image width={60} height={60} alt="Gym" src={Gym} />
              <div className="ml20">
                Join a <strong>gym</strong> that is close to you
              </div>
            </div>
          </div>
          <Explanation color="blue">
            <div>
              <strong>Which gym?</strong> All the machines used by our program
              are extremely common and will be found in any affordable chain,
              such as Planet Fitness, Cardinal Fitness, Gold{`'`}s Gym, or LA
              Fitness.
            </div>
          </Explanation>
          <Explanation color="green">
            <div>
              <strong>Tip: </strong> To avoid a crowded gym, avoid peak days,
              usually Monday and Tuesday{' '}
              <Footnote link="https://www.womenshealthmag.com/fitness/a19981431/avoid-crowded-gyms/" />
              , and peak times, which are mid-mornings from 8 to 11 AM and early
              evenings from 4 to 7 PM{' '}
              <Footnote link="https://www.sparkpeople.com/resource/fitness_articles.asp?id=1259" />
              .
            </div>
          </Explanation>
          <div>
            <div className="fr mt40 mb40">
              <Image width={60} height={60} alt="Clock" src={Frequency} />
              <div className="ml20">
                <div className="bold">Frequency</div>
                <div>Lift once to twice per week</div>
              </div>
            </div>
            <Explanation color="green">
              <div>
                <strong>Tip: </strong>When you{`'`}re on a diet, you can lift
                just once per week. That{`'`}s enough to keep your muscles{' '}
                <Footnote link="https://sci-fit.net/detraining/" />.
              </div>
            </Explanation>
            <Explanation color="pink">
              <div>
                <strong>Warning: </strong>To give yourself time to recover, don
                {`'`}t lift on back-to-back days.
              </div>
            </Explanation>
          </div>
          <div>
            <div className="fr mt40 mb40">
              <Image width={60} height={60} alt="Weights" src={Volume} />
              <div className="ml20">
                <div className="bold">Volume</div>
                <div>See below</div>
              </div>
            </div>
            <Explanation color="blue">
              <div>
                <strong>Protocol: </strong>For each exercise, you do
                <strong> 5 sets</strong>, each with <strong> 10 reps</strong>.
                Between each set you should take{' '}
                <strong>1 to 3 minutes of rest</strong>.
              </div>
            </Explanation>
            <Explanation color="green" className="pb10 pt10">
              <div>
                <ul className="m0">
                  <li>
                    <strong>Rep: </strong> The act of lifting up and putting
                    down the weight one time.
                  </li>
                  <li>
                    <strong>Set:</strong> The number of reps you do before you
                    stop.
                  </li>
                  <li>
                    <strong>Rest period:</strong> How long you wait between
                    sets.
                  </li>
                </ul>
              </div>
            </Explanation>
            <div>
              <div className="fr mt40 mb40">
                <Image
                  width={60}
                  height={60}
                  alt="Graph with line going up"
                  src={Progression}
                />
                <div className="ml20">
                  <div className="bold">Progression</div>
                  <div>See below</div>
                </div>
              </div>
              <Explanation color="blue">
                <div>
                  <strong>Protocol: </strong> After hitting <strong>10</strong>{' '}
                  reps on all <strong>5</strong> sets, add{' '}
                  <strong>+2.5lbs</strong> per exercise on the{' '}
                  <strong>next</strong> workout.
                </div>
              </Explanation>
              <Explanation color="green">
                <div>
                  <strong>Tip: </strong>A set of magnetic weights, each 2.5lbs,
                  makes progression easy. We{' '}
                  <MagneticWeights text="like these" /> for $40.
                </div>
              </Explanation>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Lifting
